import React from 'react'
import './Menu.scss'
import { NavLink } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { store } from '../../../index'
import { useTranslation } from 'react-i18next'
import { PRODUCT_PERMISSION, UserRole } from '../../../configs/constants/roles.const'

interface MenuProps {
  varient: string
  values?: [
    {
      displayValue: string
      values: string
    }
  ]
}

const Menu: React.FC<MenuProps> = ({ varient, values }) => {
  const { t } = useTranslation()
  const userInfo = store.getState().loginReducer.userInfo

  const totalMenu = [
    {
      name: 'Operational Statistics',
      link: '/dashboard',
      role: [UserRole.ADMIN]
    },
    {
      name: 'License Management',
      link: '/license-key-list',
      role: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN]
    },
    {
      name: 'Release Management',
      link:
        userInfo.productManagementPermission === PRODUCT_PERMISSION.ALLOW &&
        userInfo.role === UserRole.ADMIN
          ? '/product'
          : '/release-list',
      role: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN]
    },
    {
      name: 'Country Management',
      link: '/sales-area-management',
      role: [UserRole.ES, UserRole.ADMIN]
    },
    {
      name: 'Users Management',
      link: '/user-management',
      role: [UserRole.ADMIN]
    }
  ]
  const dropdown = (
    <div className="menu">
      <Dropdown>
        <Dropdown.Toggle variant={varient}>{t('Menu')}</Dropdown.Toggle>
        <Dropdown.Menu>
          {totalMenu.map((item) => {
            return item.role.includes(userInfo.role) ? (
              <Dropdown.Item as="div" key={item.name}>
                {window.location.pathname !== item.link ? (
                  <NavLink to={item.link}>{t(item.name)}</NavLink>
                ) : (
                  <a
                    href={
                      userInfo.role === UserRole.AFFILIATE && item.link === '/release-list'
                        ? '/release-note'
                        : item.link
                    }>
                    {t(item.name)}
                  </a>
                )}
              </Dropdown.Item>
            ) : null
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
  return <div>{dropdown} </div>
}

export default Menu
